import { IDefineCommand } from 'core-ts-types';

angular
  .module('major-explorer-data')
  .factory(
    'loadMajorExplorerIntakeCommand',
    (defineCommand: IDefineCommand, PathItemBuilder: any, $http: ng.IHttpService) => {
      return defineCommand('loadMajorExplorerIntakeCommand', (deferred: ng.IDeferred<any>) => {
        $http
          .get('event/task/event_nk/E_INTAKE/repeated_by/0/')
          .then(({ data }) => {
            deferred.resolve(new PathItemBuilder(data));
          })
          .catch(() => {
            deferred.reject('failed to load data, please attempt again');
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/load_major_explorer_intake_command.ts